import React, { ComponentProps, useMemo } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import {
  SelectWithController,
} from '@fuww/library/src/SelectMenus';
import withQuery from '../lib/withQuery';
import countriesQuery from '../lib/queries/countries.graphql';

const countrySelectWithoutQueryPropertyTypes = {
  data: PropTypes.shape({
    countries: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired).isRequired,
  }).isRequired,
};

type CountrySelectWithoutQueryProperties = InferProps<
  typeof countrySelectWithoutQueryPropertyTypes
> & Omit<ComponentProps<typeof SelectWithController>, 'options'> & {
  emptyLabel?: string;
};

const CountrySelectWithoutQuery = ({
  data,
  emptyLabel,
  ...rest
} : CountrySelectWithoutQueryProperties) => {
  const countryOptions = useMemo(() => [
    { label: emptyLabel ?? '', value: '' },
    ...data.countries.map(({ name }) => ({
      label: name,
      value: name,
    })),
  ], [data, emptyLabel]);

  return (
    <SelectWithController
      options={countryOptions}
      {...rest}
    />
  );
};

const CountrySelectWithQuery = withQuery(CountrySelectWithoutQuery);

const CountrySelect = (
  properties: Omit<CountrySelectWithoutQueryProperties, 'data'>,
) => (
  <CountrySelectWithQuery
    {...properties}
    query={countriesQuery}
    fetchPolicy="cache-first"
    errorMessage="Failed to load countries"
  />
);

export default CountrySelect;
